<template>
    <div ref="selectDepartGroupDom" v-loading="loading">
        <departmentGroup :departmentList="departmentList" @clickDPBtn="goQueryCard" />
    </div>
</template>

<script setup>
    import departmentGroup from "@/components/shopopee/buttonGroup/departmentGroup.vue"
    import {ref} from 'vue'
    // import { useUserinfo } from '@/stores/userinfo'
    import cardApi from "@/request/api"
    import myUtil from "@/util/util";

    const props = defineProps(['departmentList'])
    const emits = defineEmits(['clickDPBtn'])

    // const userinfoRef = toRef(useUserinfo())

    const loading = ref(false)

    function goQueryCard(id) {
        loading.value = true
        getDepartmentCard(id)
    }

    function getDepartmentCard(id){
        const request = cardApi.queryDepartMemberwork
        const params = request.getParams()
        params.department = id

        request.send(params, fillCard)
    }

    function fillCard(res) {
        loading.value = false

        if (res.code == 200){
            // if (null != res.detail){
            //     if(res.detail.list.length > 0 && res.detail.list[0].memberworkList != null){
            //         emits("clickDPBtn", res.detail.list[0].memberworkList)
            //     }else{
            //         emits("clickDPBtn", null)
            //     }
            // }

            emits("clickDPBtn", res.detail)
        }else{
            myUtil.alertError(res.msg)
        }
    }

</script>

<style scoped>

</style>